export const DEFAULT_FILE_CATEGORY = "General";

export const ADD_HOME_SECTIONS = {
  CUSTOMER_SEARCH: "Customer Search",
  PROPERTY_TYPE: "Property Type",
  PROPERTY_INFORMATION_CHECKBOXES: "Property Information Checkboxes",
  PROPERTY_CONTACTS: "Property Contacts",
  PROPERTY_INFORMATION: "Property Information",
  ADDRESS_INFORMATION: "Address Information",
  ADDITIONAL_INFORMATION: "Additional Information (Optional)",
  CREATE_CUSTOMER: "Create Customer",
  DOCUMENTS: "Documents",
};
